var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
export var STATE_SIGN_IN = "signIn";
export var STATE_SIGN_UP = "signUp";
export var STATE_SIGNED_IN = "signedIn";
export var STATE_SIGNED_OUT = "signedOut";
export var STATE_SIGNED_UP = "signedUp";
export var STATE_SIGN_IN_CONFIRM = "confirmSignIn";
export var STATE_SIGN_UP_CONFIRM = "confirmSignUp";
export var STATE_REQUIRE_NEW_PASSWORD = "requireNewPassword";
export var STATE_SETUP = "TOTPSetup";
export var STATE_VERIFY_CONTACT = "verifyContact";
var AuthComponent = /** @class */ (function (_super) {
    __extends(AuthComponent, _super);
    function AuthComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthComponent.prototype.shouldRender = function (currentAuthState) {
        return this.getValidAuthStates().includes(currentAuthState);
    };
    AuthComponent.prototype.render = function () {
        var authState = this.props.authState;
        if (authState && this.shouldRender(authState))
            return this.renderComponent(authState);
        return null;
    };
    AuthComponent.prototype.changeAuthState = function (state, data) {
        var onStateChange = this.props.onStateChange;
        if (onStateChange)
            onStateChange(state, data);
        else
            console.error("onStateChange() is undefined!");
    };
    return AuthComponent;
}(React.PureComponent));
export default AuthComponent;
//# sourceMappingURL=AuthComponent.js.map